// NPA (Non Personalised Ads) checking process:
// check is use in CCPA (California Consumer Privacy Act) Region -> get value for Ccpa
// else check if user is in EU Region -> get value for consent cookie

import ConsentCookie from 'scripts/lib/ConsentCookie'
import { getCcpaVal, isCcpaEligible } from 'scripts/helpers/CcpaHelper'
import Constants from 'scripts/base/Constants'

const Country = () => window && window.esiParams ? window.esiParams.cc : 'xx'

// check if user has opted in remarketing ads or ccpa share data
// returns false if the user has opted-in for remarketing or ccpa share date
export const isNpa = () => {
  if (isCcpaEligible()) {
    return !getCcpaVal().value // true = opt-in to share
  } else if (Constants.EU.indexOf(Country().toLowerCase()) !== -1) {
    let consent = new ConsentCookie()
    return !consent.hasConsent('advertising') // true = opt-in for remarketing
  }

  return false
}

export const isAdvertisingEnabled = () => {
  if (Constants.EU.indexOf(Country().toLowerCase()) !== -1) {
    let consent = new ConsentCookie()
    return consent.hasConsent('advertising') // true = opt-in for remarketing
  }

  return true
}

export const isCookieActive = () => {
  let consent = new ConsentCookie()
  if (typeof consent.GetData() !== 'undefined') {
    return true
  }
  return false
}

export const isAdsCookieEnabled = () => {
  if (Constants.EU.indexOf(Country().toLowerCase()) !== -1) {
    let consent = new ConsentCookie()
    if (typeof consent.GetData() !== 'undefined') {
      return consent.hasConsent('advertising')
    }
    return false
  }
  return false
}

export const isCountryValidEnabled = () => {
  if (Constants.EU.indexOf(Country().toLowerCase()) !== -1) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./assets/js/helpers/AdsNpaHelper.jsx